// Em src/components/Footer.js
import React from 'react';
import { FaLinkedin, FaGithub, FaInstagram } from 'react-icons/fa';
import styles from './Footer.module.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.appFooter}>
      <div className={styles.footerContainer}>
        <span className={styles.copyright}>
          &copy; {currentYear} Sistema de Imóveis. Desenvolvido por{' '}
          {/* NOME AGORA É UM LINK ESTILIZADO */}
          <a 
            href="https://github.com/seu-usuario" // Coloque seu link aqui
            target="_blank" 
            rel="noopener noreferrer" 
            className={styles.developerLink}
          >
            Lucas Borinelli Mees
          </a>.
        </span>

        <div className={styles.socialLinks}>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="LinkedIn">
            <FaLinkedin />
          </a>
          <a href="https://github.com" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="GitHub">
            <FaGithub />
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="Instagram">
            <FaInstagram />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;